import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punehyundaiauracab() {



  const cardData = {




keyword: "Pune Hyundai Aura Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune Hyundai Aura Cab Service for airport transfers, corporate travel, family journeys, railway station transfers, local sightseeing, and long-distance trips. The Hyundai Aura offers comfortable seating, practical luggage space, smooth performance, and an economical travel option for individuals, couples, and small families. Customers can book a chauffeur-driven Aura for one-way journeys, round trips, airport pickup and drop, business travel, hotel transfers, and customized travel plans. With clean and well-maintained cars, experienced drivers, flexible pickup locations, transparent pricing, and 24/7 customer assistance, Garud Cab Service offers convenient and dependable transportation from Pune to a wide range of destinations.",

topPlaces: [
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a prominent religious destination in the Sahyadri region and is known for the revered Bhimashankar Jyotirlinga Temple surrounded by forests and scenic hills. Devotees and nature lovers frequently travel here from Pune for spiritual visits and peaceful escapes. A Hyundai Aura is suitable for couples and small families seeking a private and economical journey, with comfortable seating and convenient luggage space."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a picturesque hill station known for Table Land, scenic viewpoints, strawberry farms, green valleys, and pleasant weather. It is a popular choice for couples and families looking for a relaxing trip from Pune. Garud Cab Service provides chauffeur-driven Hyundai Aura cabs for direct journeys, return trips, and customized sightseeing covering Panchgani and nearby attractions."
  },
  {
    title: "Malshej Ghat",
    description: "Malshej Ghat is a beautiful Western Ghats destination featuring misty mountains, waterfalls, deep valleys, and scenic roads. The area is particularly attractive during the monsoon and is popular with nature lovers and weekend travelers. A Hyundai Aura offers a comfortable private travel option for smaller groups, allowing passengers to enjoy flexible stops and a personalized sightseeing schedule."
  },
  {
    title: "Bhandardara",
    description: "Bhandardara is a peaceful destination surrounded by mountains, forests, lakes, and waterfalls, making it suitable for travelers looking for a quiet nature getaway. Attractions around the region include Arthur Lake and Randha Falls. Customers can book a Hyundai Aura from Pune for a comfortable journey with a professional chauffeur, whether they need direct transportation or a complete return trip."
  },
  {
    title: "Dapoli",
    description: "Dapoli is a scenic Konkan destination known for beaches, coastal villages, temples, greenery, and a relaxed holiday atmosphere. The road journey from Pune is well suited for couples and small families who prefer private transportation. Garud Cab Service offers Hyundai Aura bookings for one-way and round trips, with flexible pickup locations and customized coastal sightseeing options."
  },
  {
    title: "Kashid",
    description: "Kashid is a popular coastal destination known for its sandy beach, sea views, greenery, and peaceful surroundings. It is ideal for couples and families planning a relaxing beach getaway from Pune. The Hyundai Aura provides comfortable seating for smaller groups and practical luggage space for a short holiday. Customers can also include nearby coastal attractions in their customized cab itinerary."
  },
  {
    title: "Panhala",
    description: "Panhala is a historic hill destination near Kolhapur known for Panhala Fort, scenic mountain views, and its connection with Maratha history. The area is suitable for history enthusiasts, families, and weekend travelers. A Hyundai Aura cab provides a convenient private option for smaller groups traveling from Pune, with flexible arrangements for sightseeing and return travel."
  },
  {
    title: "Narsobawadi",
    description: "Narsobawadi is an important spiritual destination in Maharashtra associated with Lord Dattatreya and Shri Narasimha Saraswati. Located near the Krishna River, it offers a peaceful atmosphere for devotees and religious travelers. Garud Cab Service provides chauffeur-driven Hyundai Aura travel from Pune for couples and small families, with the option to include additional temples and nearby destinations."
  },
  {
    title: "Tarkarli",
    description: "Tarkarli is a scenic Konkan destination known for beautiful beaches, coastal landscapes, clear waters, and a peaceful village atmosphere. It is a suitable choice for travelers planning an extended beach holiday from Pune. A Hyundai Aura provides a private and comfortable road-trip option for smaller groups, while flexible booking allows customers to plan one-way or return travel according to their itinerary."
  },
  {
    title: "Satara",
    description: "Satara is a scenic city surrounded by the Sahyadri ranges and offers access to attractions such as Kaas Plateau, Thoseghar Waterfalls, and historic forts. It is a convenient destination for families, couples, and nature lovers traveling from Pune. Customers can book a Hyundai Aura for direct transportation or create a customized sightseeing route covering multiple attractions around Satara."
  }
],




"services": [
{
"name": "Aura Cab Service in Pune",
"description": "Book Aura Cab Service in Pune for comfortable and reliable local, airport, corporate, and outstation transportation with professional chauffeurs and well-maintained air-conditioned Hyundai Aura cars. The service is suitable for individuals, families, tourists, business travelers, airport passengers, and customers planning one-way or round-trip journeys."
},
{
"name": "Hyundai Aura Rental Pune",
"description": "Choose Hyundai Aura Rental Pune for convenient chauffeur-driven transportation with comfortable AC interiors, practical luggage space, and flexible travel arrangements. Hyundai Aura is suitable for local travel, airport transfers, office visits, family journeys, sightseeing, corporate requirements, and outstation trips from Pune."
},
{
"name": "Hyundai Aura Taxi Booking Pune",
"description": "Make Hyundai Aura Taxi Booking Pune for a comfortable private journey with an experienced chauffeur and clean air-conditioned sedan. The service is suitable for airport transfers, office travel, family transportation, sightseeing, hotel transfers, personal visits, and outstation journeys with convenient pickup and destination drop."
},
{
"name": "Sedan Cab Service Pune",
"description": "Book Sedan Cab Service Pune with Hyundai Aura and other comfortable sedan options for reliable city, airport, corporate, and outstation transportation. Enjoy professional chauffeur service, AC interiors, comfortable seating, practical luggage space, and flexible travel arrangements for individuals, families, tourists, and business passengers."
},
{
"name": "Hyundai Aura Car Booking Pune",
"description": "Reserve Hyundai Aura Car Booking Pune for private chauffeur-driven transportation with convenient pickup and direct destination drop. The comfortable sedan is suitable for local travel, airport transfers, business meetings, family trips, sightseeing, hotel transportation, and outstation journeys requiring a practical and comfortable vehicle."
},
{
"name": "Aura Outstation Cab Pune",
"description": "Choose Aura Outstation Cab Pune for comfortable long-distance transportation with a professional chauffeur and well-maintained AC Hyundai Aura. The sedan is suitable for one-way transfers, round trips, family travel, corporate journeys, sightseeing, personal visits, and intercity transportation from Pune."
},
{
"name": "Hyundai Aura Airport Transfer Pune",
"description": "Book Hyundai Aura Airport Transfer Pune for convenient scheduled pickup and drop services to and from Pune Airport. Enjoy a comfortable AC sedan with practical luggage space and professional chauffeur service for business travelers, families, tourists, individuals, and passengers requiring reliable airport transportation."
},
{
"name": "Pune Aura Car Hire",
"description": "Hire a Pune Aura Car with a professional chauffeur for comfortable and convenient transportation across Pune and nearby destinations. Hyundai Aura provides AC interiors, comfortable seating, practical luggage capacity, and flexible travel options for airport transfers, office travel, sightseeing, family trips, and outstation journeys."
},
{
"name": "Hyundai Aura Tourist Vehicle Pune",
"description": "Choose Hyundai Aura Tourist Vehicle Pune for comfortable sightseeing and private tourist transportation with an experienced chauffeur. The sedan is suitable for couples, families, small groups, visitors, and travelers exploring Pune or nearby destinations with convenient pickup and flexible sightseeing arrangements."
},
{
"name": "Hyundai Aura Online Cab Booking Pune",
"description": "Make Hyundai Aura Online Cab Booking Pune for convenient private transportation with scheduled pickup and direct destination drop. Select the Hyundai Aura for local rides, airport transfers, corporate travel, sightseeing, family journeys, hotel transfers, and outstation trips while enjoying comfortable AC travel."
},
{
"name": "Hyundai Aura Cabs in Hinjewadi Pune",
"description": "Book Hyundai Aura Cabs in Hinjewadi Pune for comfortable transportation to IT parks, offices, residential areas, Pune Airport, hotels, and outstation destinations. Professional chauffeur service and AC interiors make the vehicle suitable for employees, corporate travelers, families, airport passengers, and personal travel."
},
{
"name": "Hyundai Aura Cabs in Kharadi Pune",
"description": "Choose Hyundai Aura Cabs in Kharadi Pune for reliable local, airport, corporate, and outstation transportation. Enjoy convenient pickup from homes, offices, hotels, and business locations with a professional chauffeur, comfortable AC seating, and practical luggage space for individuals, families, and business passengers."
},
{
"name": "Hyundai Aura Cabs in Hadapsar Pune",
"description": "Book Hyundai Aura Cabs in Hadapsar Pune for comfortable city and outstation travel with convenient pickup arrangements and professional chauffeur service. The sedan is suitable for office travel, airport transfers, family journeys, sightseeing, hotel transfers, and private trips from Hadapsar to destinations across Maharashtra."
},
{
"name": "Hyundai Aura Cabs in Baner Pune",
"description": "Reserve Hyundai Aura Cabs in Baner Pune for comfortable transportation to offices, hotels, Pune Airport, residential areas, and outstation destinations. The AC sedan provides convenient seating and luggage space for corporate travelers, families, tourists, and individuals requiring reliable chauffeur-driven travel."
},
{
"name": "Hyundai Aura Cabs in Wakad Pune",
"description": "Hire Hyundai Aura Cabs in Wakad Pune for convenient local, airport, corporate, and outstation transportation. Enjoy professional chauffeur service, clean AC interiors, comfortable seating, and scheduled pickup from homes, offices, hotels, and other locations in Wakad for private travel."
},
{
"name": "Hyundai Aura Cabs in Pimpri Chinchwad",
"description": "Book Hyundai Aura Cabs in Pimpri Chinchwad for reliable transportation across PCMC, Pune Airport, business locations, residential areas, and outstation destinations. Hyundai Aura is suitable for individuals, families, corporate passengers, tourists, and small groups looking for comfortable chauffeur-driven sedan travel."
},
{
"name": "Hyundai Aura Cabs in Viman Nagar Pune",
"description": "Choose Hyundai Aura Cabs in Viman Nagar Pune for convenient airport transfers, local travel, business transportation, hotel pickups, and outstation journeys. With comfortable AC interiors, practical luggage space, and professional chauffeurs, the sedan is suitable for travelers staying near hotels, offices, and Pune Airport."
},
{
"name": "Hyundai Aura Cabs in Kothrud Pune",
"description": "Reserve Hyundai Aura Cabs in Kothrud Pune for comfortable city rides, airport transfers, family travel, sightseeing, and outstation transportation. Enjoy convenient door-to-door pickup, experienced chauffeur service, AC seating, and a practical sedan option for individuals, couples, families, and small groups."
},
{
"name": "Hyundai Aura Cabs in Magarpatta Pune",
"description": "Book Hyundai Aura Cabs in Magarpatta Pune for corporate travel, airport transfers, local transportation, hotel pickups, and outstation journeys. The comfortable AC sedan is suitable for professionals, families, tourists, and individuals requiring scheduled chauffeur-driven transportation from Magarpatta."
},
{
"name": "Hyundai Aura Cabs in Wagholi Pune",
"description": "Choose Hyundai Aura Cabs in Wagholi Pune for reliable local and long-distance transportation with convenient pickup and destination drop. The sedan provides comfortable AC travel for office commuters, families, airport passengers, tourists, and customers planning outstation journeys from Wagholi."
},
{
"name": "Hyundai Aura Cabs in Pune",
"description": "Book Hyundai Aura Cabs in Pune for comfortable private transportation with professional chauffeurs and well-maintained AC vehicles. The service is suitable for local rides, airport transfers, corporate travel, sightseeing, family trips, hotel transfers, one-way journeys, and outstation transportation."
},
{
"name": "Hyundai Aura Cab Service Pune",
"description": "Choose Hyundai Aura Cab Service Pune for dependable chauffeur-driven sedan transportation with comfortable AC interiors and convenient pickup arrangements. The service is suitable for business travel, airport transfers, family trips, tourist journeys, local transportation, hotel transfers, and outstation travel from Pune."
},
{
"name": "Hyundai Aura Taxi Service Pune",
"description": "Book Hyundai Aura Taxi Service Pune for private and comfortable travel with experienced drivers and clean air-conditioned vehicles. Customers can use the sedan for city rides, airport transfers, corporate transportation, sightseeing, family journeys, hotel transfers, and outstation trips."
},
{
"name": "Hyundai Aura Cab Booking Pune",
"description": "Make Hyundai Aura Cab Booking Pune for scheduled chauffeur-driven transportation with convenient pickup and direct drop facilities. Select the Hyundai Aura according to your passenger count, luggage requirements, travel date, and preferred timing for local, airport, corporate, tourist, and outstation travel."
},
{
"name": "Hyundai Aura Car Rental Pune",
"description": "Hire Hyundai Aura Car Rental Pune with a professional chauffeur for comfortable and convenient transportation throughout Pune and nearby destinations. The sedan offers AC interiors, comfortable seating, practical luggage space, and flexible travel options for local, airport, corporate, tourist, family, and outstation journeys."
},
{
"name": "Hyundai Aura Outstation Cab Pune",
"description": "Choose Hyundai Aura Outstation Cab Pune for comfortable intercity travel with a professional chauffeur and well-maintained AC sedan. The service is suitable for one-way trips, round trips, family travel, business journeys, sightseeing, personal visits, and long-distance transportation from Pune."
},
{
"name": "Hyundai Aura Airport Cab Pune",
"description": "Reserve Hyundai Aura Airport Cab Pune for convenient pickup and drop transportation to and from Pune Airport. Enjoy comfortable AC seating, practical luggage space, professional chauffeur service, and scheduled travel suitable for business passengers, families, tourists, individuals, and airport travelers."
},
{
"name": "Online Hyundai Aura Booking Pune",
"description": "Book Online Hyundai Aura Booking Pune for convenient chauffeur-driven transportation with scheduled pickup and direct destination drop. The Hyundai Aura is suitable for airport transfers, local travel, corporate transportation, sightseeing, family journeys, hotel transfers, and outstation trips requiring a comfortable sedan."
},
{
"name": "Hyundai Aura Sedan Cab Pune",
"description": "Choose Hyundai Aura Sedan Cab Pune for practical and comfortable private transportation with air-conditioned interiors and professional chauffeur service. The sedan is suitable for individuals, couples, small families, corporate travelers, airport passengers, tourists, local rides, and outstation journeys."
},
{
"name": "Hyundai Aura Taxi Booking Pune",
"description": "Reserve Hyundai Aura Taxi Booking Pune for convenient chauffeur-driven transportation with scheduled pickup and direct destination drop. The comfortable sedan is suitable for airport travel, corporate requirements, family trips, sightseeing, local transportation, hotel transfers, and outstation journeys from Pune."
},
{
"name": "Hyundai Aura Sedan Rental Pune",
"description": "Choose Hyundai Aura Sedan Rental Pune for comfortable chauffeur-driven transportation with AC interiors, practical luggage space, and flexible rental arrangements. The sedan is suitable for local travel, airport transfers, business visits, family journeys, sightseeing, hotel transfers, and outstation transportation."
},
{
"name": "Hyundai Aura Airport Cab Pune",
"description": "Book Hyundai Aura Airport Cab Pune for reliable airport pickup and drop services with professional chauffeurs and comfortable AC interiors. The sedan provides practical luggage capacity and scheduled transportation for individuals, families, tourists, corporate passengers, and travelers using Pune Airport."
},
{
"name": "Hyundai Aura Corporate Cab Pune",
"description": "Choose Hyundai Aura Corporate Cab Pune for professional transportation for office travel, client meetings, employee movement, business events, hotel transfers, and airport journeys. Comfortable AC sedan interiors, trained chauffeurs, and convenient pickup arrangements provide a practical solution for corporate passengers."
},
{
"name": "Hyundai Aura Tourist Taxi Pune",
"description": "Book Hyundai Aura Tourist Taxi Pune for comfortable private sightseeing and tourist transportation with an experienced chauffeur. The sedan is suitable for couples, families, small groups, visitors, and travelers exploring Pune and nearby attractions with flexible pickup and customized travel arrangements."
},
{
"name": "Hyundai Aura Family Travel Cab Pune",
"description": "Choose Hyundai Aura Family Travel Cab Pune for comfortable private transportation with AC seating, practical luggage space, and a professional chauffeur. The sedan is suitable for family outings, airport transfers, hotel travel, sightseeing, personal visits, and convenient outstation journeys."
},
{
"name": "Hyundai Aura Outstation Car Rental Pune",
"description": "Hire Hyundai Aura Outstation Car Rental Pune with a professional chauffeur for comfortable intercity transportation. Enjoy AC interiors, comfortable seating, practical luggage space, and flexible one-way or round-trip travel options for family trips, business journeys, sightseeing, personal visits, and long-distance travel."
}
],
"tableData": [
["Aura Cab Service in Pune", "Hyundai Aura Rental Pune"],
["Hyundai Aura Taxi Booking Pune", "Sedan Cab Service Pune"],
["Hyundai Aura Car Booking Pune", "Aura Outstation Cab Pune"],
["Hyundai Aura Airport Transfer Pune", "Pune Aura Car Hire"],
["Hyundai Aura Tourist Vehicle Pune", "Hyundai Aura Online Cab Booking Pune"],
["Hyundai Aura Cabs in Hinjewadi Pune", "Hyundai Aura Cabs in Kharadi Pune"],
["Hyundai Aura Cabs in Hadapsar Pune", "Hyundai Aura Cabs in Baner Pune"],
["Hyundai Aura Cabs in Wakad Pune", "Hyundai Aura Cabs in Pimpri Chinchwad"],
["Hyundai Aura Cabs in Viman Nagar Pune", "Hyundai Aura Cabs in Kothrud Pune"],
["Hyundai Aura Cabs in Magarpatta Pune", "Hyundai Aura Cabs in Wagholi Pune"],
["Hyundai Aura Cabs in Pune", "Hyundai Aura Cab Service Pune"],
["Hyundai Aura Taxi Service Pune", "Hyundai Aura Cab Booking Pune"],
["Hyundai Aura Car Rental Pune", "Hyundai Aura Outstation Cab Pune"],
["Hyundai Aura Airport Cab Pune", "Online Hyundai Aura Booking Pune"],
["Hyundai Aura Sedan Cab Pune", "Hyundai Aura Taxi Booking Pune"],
["Hyundai Aura Sedan Rental Pune", "Hyundai Aura Airport Cab Pune"],
["Hyundai Aura Corporate Cab Pune", "Hyundai Aura Tourist Taxi Pune"],
["Hyundai Aura Family Travel Cab Pune", "Hyundai Aura Outstation Car Rental Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Pune Hyundai Aura Cab for Comfortable City Rides",
    WhyChoosedescription: "Garud Cab Service offers Hyundai Aura cab services in Pune for daily transportation, airport transfers, business visits, family travel, railway station drops, and selected outstation journeys."
  },
  {
    WhyChooseheading: "Compact Sedan for Convenient Travel",
    WhyChoosedescription: "Hyundai Aura is a practical sedan for individuals, couples, and small families who want private transportation with comfortable seating and useful luggage space."
  },
  {
    WhyChooseheading: "Easy Pune Airport Transfers",
    WhyChoosedescription: "Book a Hyundai Aura for Pune Airport pickup or drop when travelling between the airport and your home, hotel, office, railway station area, or another preferred destination."
  },
  {
    WhyChooseheading: "Suitable for Business & Corporate Trips",
    WhyChoosedescription: "Aura cabs can be used for client meetings, office visits, business appointments, interviews, corporate transfers, and other professional travel requirements across Pune."
  },
  {
    WhyChooseheading: "Useful for Local Pune Transportation",
    WhyChoosedescription: "Hire a Hyundai Aura for shopping trips, hotel transfers, family visits, appointments, city sightseeing, social functions, and other regular transportation requirements."
  },
  {
    WhyChooseheading: "Private Travel for Small Families",
    WhyChoosedescription: "Families with a small number of passengers can choose an Aura cab for private travel, offering a convenient alternative to larger vehicles when passenger and luggage requirements are moderate."
  },
  {
    WhyChooseheading: "Outstation Travel from Pune",
    WhyChoosedescription: "Hyundai Aura cab arrangements can be considered for suitable outstation routes from Pune, including short holidays, family visits, religious journeys, and intercity travel."
  },
  {
    WhyChooseheading: "Flexible Booking with Garud Cab Service",
    WhyChoosedescription: "Share your pickup point, destination, travel date, passenger details, and one-way or return requirement with Garud Cab Service to arrange a Hyundai Aura cab according to your plans."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune Hyundai Aura Cab Service?",
    answer: "Yes, Garud Cab Service provides Hyundai Aura cabs in Pune for local travel, airport transfers, corporate trips, family transportation, railway station transfers, and suitable outstation journeys."
  },
  {
    question: "Can I book a Hyundai Aura for Pune Airport?",
    answer: "Yes, Hyundai Aura can be booked for Pune Airport pickup and drop services according to your flight schedule and preferred travel timing."
  },
  {
    question: "Is Hyundai Aura suitable for small families?",
    answer: "Yes, Hyundai Aura is a practical sedan for individuals, couples, and small families travelling with moderate luggage."
  },
  {
    question: "Can I use a Hyundai Aura for corporate travel?",
    answer: "Yes, Aura cabs can be used for office travel, client meetings, business appointments, interviews, corporate events, and other professional transportation needs."
  },
  {
    question: "Can I book Hyundai Aura for outstation travel?",
    answer: "Yes, Hyundai Aura can be arranged for suitable outstation destinations from Pune based on the route, travel date, and vehicle availability."
  },
  {
    question: "Can I book a one-way Hyundai Aura cab?",
    answer: "Yes, one-way Aura cab service can be arranged when you require direct transportation from Pune to your selected destination."
  },
  {
    question: "Is round-trip Aura cab service available?",
    answer: "Yes, round-trip arrangements can be planned for sightseeing, family visits, business travel, religious trips, airport transfers, and holidays."
  },
  {
    question: "Can I hire an Aura cab for Pune sightseeing?",
    answer: "Yes, Hyundai Aura can be arranged for local sightseeing, shopping, hotel transfers, family outings, appointments, and other city transportation requirements."
  },
  {
    question: "Is the Hyundai Aura available with a driver?",
    answer: "Yes, chauffeur-driven Hyundai Aura service can be arranged for customers who prefer private transportation with a professional driver."
  },
  {
    question: "How can I book a Pune Hyundai Aura Cab?",
    answer: "Share your pickup location, destination, travel date, passenger count, and trip type with Garud Cab Service to arrange your Hyundai Aura cab."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Pawar",
    feedback: "I booked a Hyundai Aura for a Pune Airport transfer and the sedan was a convenient choice for my trip. The private pickup made the journey simple.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shweta Kulkarni",
    feedback: "Our small family used the Aura cab for local Pune travel. The car was comfortable for our group and worked well for our luggage requirements.",
    rating: 5
  }
];





  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Hyundai Aura Cab",
  "image": "https://garudcabs.com/assets/images/pune-hyundai-aura-cab.webp",
  "description": "Book Pune Hyundai Aura Cab with Garud Cab for comfortable, economical, and reliable local, airport, tourist, and outstation travel. Get Hyundai Aura rental, taxi booking, car hire, airport transfer, and sightseeing cab services in Pune with convenient options for one way trips, round trips, family travel, corporate journeys, and intercity transportation.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-hyundai-aura-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Pune Hyundai Aura Cab | Rental, Airport & Taxi Service | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune Hyundai Aura Cab with Garud Cab for comfortable and affordable travel. Get Hyundai Aura rental, taxi booking, car hire, airport transfer, tourist, and outstation cab services in Pune with convenient one way and round trip options."
  />

  <meta
    name="keywords"
    content="Aura Cab Service in Pune, Hyundai Aura Rental Pune, Hyundai Aura Taxi Booking Pune, Sedan Cab Service Pune, Hyundai Aura Car Booking Pune, Aura Outstation Cab Pune, Hyundai Aura Airport Transfer Pune, Pune Aura Car Hire, Hyundai Aura Tourist Vehicle Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/43.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punehyundaiauracab;